export enum UserGuideTabs {
  Welcome = 'welcome',
  Collections = 'collections',
  Editor = 'editor',
  MyProfile = 'my-profile',
  ShopifyIntegration = 'shopify-integration',
  PrintingAndShipping = 'printing-and-shipping'
}
